module.exports = __webpack_public_path__ + "img/gdq_gbt858_1988.prt.26e5ef61.jpg";